import { render } from "./Block.vue?vue&type=template&id=03040c50"
import script from "./Block.vue?vue&type=script&lang=js"
export * from "./Block.vue?vue&type=script&lang=js"

import "./Block.vue?vue&type=style&index=0&id=03040c50&lang=css"

import exportComponent from "C:\\Users\\Korbin\\Documents\\Vue\\vuetutorial\\reaction-timer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__